import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
  strict: true,
  getters: {

  },
  state: {

  },
  mutations: {

  },

});

export default store
